import React from 'react';
import { Key, Sparkles } from 'lucide-react';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <div className="relative mr-2">
        <Sparkles 
          className="absolute -top-[8%] left-[10%] h-3 w-3 text-[#2C3E2E]" 
          strokeWidth={1.5} 
        />
        <Key className="h-8 w-8 text-[#2C3E2E]" strokeWidth={1.5} />
      </div>
      <span className="font-abadi font-medium text-2xl tracking-wide">
        <span className="text-[#2C3E2E]">RentSparks</span>
      </span>
    </div>
  );
};

export default Logo;